import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { authService } from '../services/authService';
import './AuthPage.css';

const ForgotPasswordPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      await authService.forgotPassword(email);
      setSuccess(t('auth.codeSentSuccess'));
      setTimeout(() => {
        navigate('/reset-password', { state: { email } });
      }, 2000);
    } catch (err: any) {
      setError(err.response?.data?.error || t('auth.fail'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-wrapper">
        {/* Illustration Side */}
        <div className="auth-illustration">
          <div className="auth-illustration-content">
            <div className="auth-illustration-icon">🔐</div>
            <h1>{t('auth.forgotPasswordTitle')}</h1>
            <p>
              {t('auth.forgotPasswordDesc')}
            </p>
          </div>
        </div>

        {/* Form Side */}
        <div className="auth-container">
          <div className="auth-header">
            <h2>{t('auth.forgotPasswordHeader')}</h2>
            <p>{t('auth.forgotPasswordSub')}</p>
          </div>

          {error && (
            <div className="error-message" role="alert">
              {error}
            </div>
          )}

          {success && (
            <div className="success-message" role="alert">
              {success}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">{t('auth.email')}</label>
              <div className={`input-wrapper ${email ? 'has-value' : ''}`}>
                <span className="input-icon">📧</span>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t('auth.emailPlaceholder')}
                  required
                  title={t('common.validation.required')}
                  onInvalid={(e) => (e.target as HTMLInputElement).setCustomValidity(t('common.validation.required'))}
                  onInput={(e) => (e.target as HTMLInputElement).setCustomValidity('')}
                  disabled={loading || !!success}
                />
              </div>
            </div>

            <button
              type="submit"
              className="auth-button"
              disabled={loading || !!success}
            >
              {loading ? t('auth.sending') : success ? t('auth.codeSentSuccess') : t('auth.sendResetCode')}
            </button>
          </form>

          <div className="auth-footer">
            <p>
              {t('auth.rememberPassword')}{' '} <Link to="/login">{t('auth.loginButton')}</Link>
            </p>
            <p>
              {t('auth.noAccount')}{' '} <Link to="/register">{t('auth.registerNow')}</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;



